import {z} from 'zod';
import {Role} from '../../user';
import {usernameValidator} from './username';
import {tm} from '../../../i18n';

export const updateUserValidator = z.object({
    username: usernameValidator,
    email: z.string().email(tm('registerPage.errorMessages.email')),
    roles: z.array(z.nativeEnum(Role)),
    passwordExpirationTime: z.number().int(),
});
